import { render, staticRenderFns } from "./allocationInventoryPage.vue?vue&type=template&id=2071a1ca&scoped=true&"
import script from "./allocationInventoryPage.vue?vue&type=script&lang=js&"
export * from "./allocationInventoryPage.vue?vue&type=script&lang=js&"
import style0 from "./allocationInventoryPage.vue?vue&type=style&index=0&id=2071a1ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2071a1ca",
  null
  
)

export default component.exports